import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip, Checkbox, Icon } from '@ets/design-system';
import styles from './TemplateOptions.module.scss';

type Options = {
  show?: boolean;
  update?: boolean;
  template?: MyAny; //TODO:TS this should have the type of DataManager template
};
export type TemplateOptionsProps = {
  options: Options;
  setOptions: (props: Options) => void;
};

const TemplateOptions = ({ options, setOptions }: TemplateOptionsProps) => {
  const intl = useIntl();

  const handleOnChange = () => {
    setOptions({ ...options, update: !options.update });
  };

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <FormattedMessage id="TEMPLATE_OPTIONS" />
      </div>
      <div className={styles.checkbox}>
        <Checkbox
          checked={options.update ?? false}
          onChange={handleOnChange}
          size="xs"
          testId="automatically-update-document-styles"
        >
          <FormattedMessage id="AUTOMATICALLY_UPDATE_DOCUMENT_STYLES" />
        </Checkbox>
        <Tooltip
          placement="bottom"
          content={intl.formatMessage({ id: 'AUTOMATICALLY_UPDATE_DOCUMENT_STYLES_TOOLTIP' })}
          testId="automatically-update-document-styles-information"
        >
          <span className={styles.icon}>
            <Icon icon="circle-info" size="2" testId="info" color="primary" />
          </span>
        </Tooltip>
      </div>
      <div className={styles.templateInfo}>
        <FormattedMessage id="WORD_TEMPLATE" />
        <div className={styles.name} title={options.template}>
          {options.template}
        </div>
      </div>
    </div>
  );
};

export default TemplateOptions;
